import * as exElement from '../../../utils/element';

// ----------------------------------------------------------------------------

function show(element: HTMLElement): void {
    exElement.show(element);
}

// ----------------------------------------------------------------------------

export default show;
